import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import {IconoirXmarkCircle} from '@ey-xd/motif-icon';
import Select from '../../../../../../CoreWrappers/Select';
import Button from '../../../../../../CoreWrappers/Button';

import {labels} from '../../../../../../../util/utils';

import StyledAddExistingDomain from './StyledAddExistingDomain';

const AddExistingDomain = ({
	domain,
	projectDomains,
	renderedDomains,
	domainError,
	setDomainDuplicate,
	updateDomainName,
	remove
}) => {
	const {id} = domain;
	const [domainName, setDomainName] = useState('');
	const [showValidationError, setShowValidationError] = useState(false);
	const [duplicateValidation, setDuplicateValidation] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [isDisabled, setIsDisabled] = useState(false);

	useEffect(() => {
		if (domainError && (domain.isEmpty || domainName === '')) {
			setShowValidationError(true);
			setErrorMessage(labels.required);
		}

		if (showValidationError && (!domain.isEmpty || domainName !== '')) {
			setShowValidationError(false);
			setErrorMessage('');
		}
	}, [domainError]);

	useEffect(() => {
		const filteredList = renderedDomains.filter((el) => el.id !== id);
		const defected = filteredList.some((el) => el.isEmpty || el.isDuplicate);

		if (defected) {
			setIsDisabled(true);
		} else {
			setIsDisabled(false);
		}

		checkDuplicate(domainName, true);
	}, [renderedDomains]);

	const checkDuplicate = (domainName, isEffect) => {
		let found = false;

		if (domainName !== '') {
			found = renderedDomains.some((el) => el.label === domainName && el.id !== id);
		}

		if (found) {
			setDuplicateValidation(true);
			setDomainDuplicate(id, domainName, true);
			setErrorMessage(labels.duplicateDomain);
		}

		if (!found && duplicateValidation) {
			setDuplicateValidation(false);
			setDomainDuplicate(id, domainName, false);
		}
	};

	const handlerOnSwitchChange = (selectedId) => {
		const selectedDomainName = projectDomains.find((dom) => dom.id === selectedId)?.label;

		updateDomainName(id, selectedDomainName);
		setDomainName(selectedDomainName);
		checkDuplicate(selectedDomainName, false);

		if (showValidationError && (!domain.isEmpty || domainName !== '')) {
			setShowValidationError(false);
			setErrorMessage('');
		}
	};

	const selectProps = {
		id,
		key: id,
		name: 'table-select-name',
		label: labels.domainName,
		options: projectDomains,
		onChange: (selectedId) => handlerOnSwitchChange(selectedId),
		errorMessage: errorMessage,
		visibleOptions: 5,
		disabled: isDisabled,
		placeholder: projectDomains.length === 0 ? labels.noGroupsAdded : ''
	};

	const renderDeleteDomainBtn = () => {
		const props = {
			svg: IconoirXmarkCircle,
			iconSize: 20,
			variant: 'text',
			title: labels.remove,
			onClick: () => remove(id, domainName)
		};
		return <Button {...props} />;
	};

	return (
		<StyledAddExistingDomain className="add-existing-domain-wrap">
			<Select {...selectProps} />
			<div className="remove-existing-domain">{renderDeleteDomainBtn()}</div>
		</StyledAddExistingDomain>
	);
};

AddExistingDomain.propTypes = {
	domain: PropTypes.object,
	projectDomains: PropTypes.array,
	renderedDomains: PropTypes.array,
	domainError: PropTypes.bool,
	setDomainDuplicate: PropTypes.func,
	updateDomainName: PropTypes.func,
	remove: PropTypes.func
};

AddExistingDomain.defaultProps = {};

export default AddExistingDomain;
